// /**
// * Key code list object
// */
export const keyCode = {
  TAB: 9,
  RETURN: 13,
  ESC: 27,
  SPACE: 32,
  PAGEUP: 33,
  PAGEDOWN: 34,
  END: 35,
  HOME: 36,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40
};

// /**
// * Key code list object
// */
export const breakpoints = {
  mobile: 360,
  tablet: 768,
  tabletLandscape: 1024,
  desktopColumn: 1570,
  desktop: 1280,
  wide: 1600
};
